module.exports = "img/flags/SL.ff06606.png";